// Newest first. Source of truth: LinkedIn profile (Aug 2026).
export const experience = [
  {
    badge: "Feb 2026 – Present",
    title: "Associate Network Implementation Engineer",
    subTitle: "AT&T, Florida, USA",
    des: "Support deployment and design of fiber optic network infrastructure providing connectivity through Forged Fiber 37, an AT&T fiber provider.",
  },
  {
    badge: "Sep 2025 – Apr 2026",
    title: "Associate Network Engineer",
    subTitle: "Lumen Technologies, Florida, USA",
    des: "Designed backbone fiber network infrastructure and fiber network projects from planning through execution, coordinating with regional teams across Florida.",
  },
  {
    badge: "May 2025 – Aug 2025",
    title: "Advanced Software Engineer Intern",
    subTitle: "Kingland, Fort Myers, FL",
    des: "Contributed to the Data Refinery platform built with Go, TypeScript, and AWS (Redshift, Bedrock, EC2); authored 17,000+ lines of production-ready code in Agile sprints with senior engineers.",
  },
  {
    badge: "Aug 2021 – Dec 2023",
    title: "Research & Teaching Assistant",
    subTitle: "Whitaker College of Engineering, FGCU",
    des: "Developed IoT and network-analysis software published at IEEE and HCI venues; applied ML and statistical modeling to network traffic; tutored 200+ students in algorithms and software development.",
  },
];

export const education = [
  {
    badge: "Aug 2021 – May 2025",
    title: "B.S. in Software Engineering (Honors)",
    subTitle: "Florida Gulf Coast University (FGCU), Fort Myers, FL",
    des: "GPA: 3.70 | Honors College | Dean's List: Spring 2021 – Fall 2024 | College of Engineering Ambassador | LAC Scholarship ($100k+ over 4 years) & Research Assistant Fellowship.",
  },
  {
    badge: "Aug 2021 – May 2025",
    title: "Mathematics Minor",
    subTitle: "Florida Gulf Coast University (FGCU)",
    des: "Selected for senior project internships with Homeland Security Investigations and Google.",
  },
];
